import { getBscGlobalState } from '../../../common/utils/bsc-global-state/core';
import {
	type CategorizedStorageControlsCache,
	type CategorizedStorageControlsCacheLegacy,
	CategoryStorageType,
	PreferenceCategory,
} from '../../../types';
import { getPreferences } from '../../preferences-controls/get-preferences';

export const isThirdPartyAllowed = async (thirdParty: string): Promise<boolean> => {
	/*
    If third party has no category or data doesn't resolve, deny.
    If third party is StrictlyNecessary, allow unconditionally.
    If no preferences are stored for any other category, deny.
    If third party has a category, check preferences and allow/deny.
  */

	const { loadCache } = getBscGlobalState();

	const storageControlsData:
		| CategorizedStorageControlsCacheLegacy
		| CategorizedStorageControlsCache
		| undefined = await loadCache(CategoryStorageType.Cookies);

	let thirdPartyCategory: PreferenceCategory | null = null;

	if (storageControlsData) {
		const { thirdPartyKeys, categories } = storageControlsData;
		const thirdPartyCategoryNumber = thirdPartyKeys[thirdParty];
		const numToCategoryMap = {
			[categories.STRICTLY_NECESSARY]: PreferenceCategory.StrictlyNecessary,
			[categories.FUNCTIONAL]: PreferenceCategory.Functional,
			[categories.ANALYTICS]: PreferenceCategory.Analytics,
			[categories.MARKETING]: PreferenceCategory.Marketing,
			[categories.UNKNOWN]: PreferenceCategory.Unknown,
		};
		thirdPartyCategory =
			thirdPartyCategoryNumber !== null ? numToCategoryMap[thirdPartyCategoryNumber] : null;
	}

	// StrictlyNecessary items are always allowed regardless of stored preferences,
	// matching the behaviour of isProcessingAllowedByPreferences.
	if (thirdPartyCategory === PreferenceCategory.StrictlyNecessary) {
		return true;
	}

	// No preferences stored — deny all non-strictly-necessary third parties.
	const preferences = await getPreferences();
	if (!preferences) {
		return false;
	}

	// Check the user's stored preference for this category.
	let isAllowedByPreferences = false;
	if (thirdPartyCategory) {
		isAllowedByPreferences = preferences[thirdPartyCategory];
	}

	return isAllowedByPreferences;
};
